function throttle(fn, delay, mustRunDelay) {
    let timer;
    let tStart;
    return function () {
        const ctx = this;
        const tCurr = +new Date();
        const args = arguments;
        clearTimeout(timer);
        if (!tStart) {
            tStart = tCurr;
        }
        if (tCurr - tStart >= mustRunDelay) {
            fn.apply(ctx, args);
            tStart = tCurr;
        }
        else {
            timer = setTimeout(() => {
                fn.apply(ctx, args);
            }, delay);
        }
    };
}
function debounce(fn, wait, leading = false) {
    let timerId;
    let lastInvokeTime = 0;
    let context;
    let args;
    const execute = function () {
        fn.apply(context, args);
        lastInvokeTime = Date.now();
    };
    return function () {
        const now = Date.now();
        context = this;
        args = arguments;
        if (timerId) {
            clearTimeout(timerId);
            timerId = null;
        }
        if (leading && lastInvokeTime === 0) {
            timerId = setTimeout(() => {
                execute();
            }, wait);
            return execute();
        }
        const timeSinceLastInvoke = now - lastInvokeTime;
        const diff = wait - timeSinceLastInvoke;
        if (diff > 0) {
            timerId = setTimeout(() => {
                execute();
            }, diff);
        }
        else {
            if (leading) {
                return execute();
            }
            timerId = setTimeout(() => {
                execute();
            }, wait);
        }
    };
}
function throttleWithArgs(fn, delay, mustRunDelay) {
    const timerId = {};
    const tStart = {};
    const argsRef = new Map(); // key is object so we need to use Map<T, U>
    let maxId = 0;
    return function () {
        const ctx = this;
        const tCurr = +new Date();
        const realArgs = arguments;
        const eventArgs = realArgs[0];
        let argsUniqueId = argsRef.get(eventArgs);
        if (!argsRef.has(eventArgs)) {
            argsUniqueId = maxId++;
            argsRef.set(eventArgs, argsUniqueId);
        }
        clearTimeout(timerId[argsUniqueId]);
        if (!tStart[argsUniqueId]) {
            tStart[argsUniqueId] = tCurr;
        }
        if (tCurr - tStart[argsUniqueId] >= mustRunDelay) {
            tStart[argsUniqueId] = tCurr;
            fn.apply(ctx, realArgs); // keep the unique id because we need to use them in the future invoke
        }
        else {
            timerId[argsUniqueId] = setTimeout(() => {
                fn.apply(ctx, realArgs);
                // it is safe to delete timer/reference here
                delete tStart[argsUniqueId];
                delete timerId[argsUniqueId];
                argsRef.delete(eventArgs);
            }, delay);
        }
    };
}
// TODO: only trailing is supported now
function debounceWithArgs(fn, wait) {
    const argsRef = new Map(); // key is object so we need to use Map<T, U>
    const timerId = {};
    const lastInvokeTime = {};
    let maxId = 0;
    return function () {
        const now = Date.now();
        const realArgs = arguments;
        const eventArgs = realArgs[0];
        // calculate debounce by unique id
        let argsUniqueId = argsRef.get(eventArgs);
        if (!argsRef.has(eventArgs)) {
            argsUniqueId = maxId++;
            argsRef.set(eventArgs, argsUniqueId);
        }
        // only applied debounce in self context
        const execute = () => {
            fn.apply(this, realArgs);
            delete lastInvokeTime[argsUniqueId];
            delete timerId[argsUniqueId];
            argsRef.delete(eventArgs);
        };
        if (lastInvokeTime[argsUniqueId] === undefined) {
            lastInvokeTime[argsUniqueId] = 0;
        }
        if (timerId[argsUniqueId]) {
            clearTimeout(timerId[argsUniqueId]);
            delete timerId[argsUniqueId];
        }
        const timeSinceLastInvoke = now - lastInvokeTime[argsUniqueId];
        const diff = wait - timeSinceLastInvoke;
        if (diff > 0) {
            timerId[argsUniqueId] = setTimeout(() => {
                execute();
            }, diff);
        }
        else {
            timerId[argsUniqueId] = setTimeout(() => {
                execute();
            }, wait);
        }
    };
}

export { debounce, debounceWithArgs, throttle, throttleWithArgs };
//# sourceMappingURL=trigger.js.map
